import { createSelector } from '@reduxjs/toolkit';
import { name } from './slice';
import type { PackageUpsaleOptionsStateType } from './types';

export const getPackageUpsaleOptions = (state): PackageUpsaleOptionsStateType =>
  state[name];

export const getTransferOptions = createSelector(
  getPackageUpsaleOptions,
  (state) => state.transferOptions,
);

export const getExtraOptions = createSelector(
  getPackageUpsaleOptions,
  (state) => state.extraOptions,
);

export const getChosenOptions = createSelector(
  getPackageUpsaleOptions,
  (state) => state.chosenOptions,
);
